const dev = {
   API_ENDPOINT_URL: "https://dev.api.urdocto.com/api",
   BACKEND_URL: "https://dev.api.urdocto.com",
  
 // API_ENDPOINT_URL: "http://localhost:5005/api",
 // BACKEND_URL: "http://localhost:5005",
}

const prod = {
  API_ENDPOINT_URL: "https://api.urdocto.com/api",
  BACKEND_URL: "https://api.urdocto.com",
}

const test = {
  API_ENDPOINT_URL: "https://dev.api.urdocto.com/api",
  BACKEND_URL: "https://dev.api.urdocto.com",
}

const getEnv = () => {
  switch (process.env.REACT_APP_STAGE) {
    case "development":
      return dev
    case "production":
      return prod
    case "test":
      return test
    default:
      return dev
  }
}

export const env = getEnv()
